// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2518":"1085b6b0","7542":"5ac63113"}[chunkId] + ".chunk.css";
};